<template>
  <div class="p-6 space-y-4">
    <div class="flex flex-wrap items-center gap-1 text-sm">
      <router-link to="/pages" class="text-blue-600 hover:underline">Pages</router-link>
      <template v-for="part in crumbs" :key="part.stem">
        <span class="text-gray-400">/</span>
        <router-link :to="folderUrl(part.stem)" class="text-blue-600 hover:underline sensitive">{{ part.name }}</router-link>
      </template>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <h1 class="text-lg font-semibold text-gray-900 sensitive">{{ crumbs.length ? crumbs[crumbs.length - 1].name : 'Pages' }}</h1>
      <div v-if="stem" class="ml-auto flex flex-wrap items-center gap-2">
        <button type="button" :class="BTN" @click="startRename">Rename</button>
        <select :class="BTN" value="" @change="moveFolder($event.target.value)">
          <option value="" disabled>Move to...</option>
          <option value="/">Top level</option>
          <option v-for="option in moveTargets" :key="option.stem" :value="option.stem">{{ '— '.repeat(option.depth) }}{{ option.label }}</option>
        </select>
      </div>
    </div>
    <form v-if="renaming" class="flex items-center gap-2" @submit.prevent="rename">
      <input v-model="draft" type="text" maxlength="60" class="border border-gray-300 rounded-md px-3 py-1.5 text-sm w-72 sensitive" />
      <button type="submit" :class="BTN" :disabled="!draft.trim()">Save</button>
      <button type="button" :class="BTN" @click="renaming = false">Cancel</button>
    </form>
    <p v-if="error" class="text-sm text-red-700">{{ error }}</p>
    <div class="bg-white border border-gray-200 rounded-lg divide-y divide-gray-100">
      <router-link v-for="child in subfolders" :key="`f-${child.stem}`" :to="folderUrl(child.stem)" class="flex items-center gap-2 px-4 py-2.5 no-underline text-sm text-gray-900 hover:bg-gray-50">
        <font-awesome-icon :icon="['fas', 'folder']" class="text-gray-400" />
        <span class="sensitive">{{ child.name }}</span>
      </router-link>
      <router-link v-for="page in pagesHere" :key="`p-${page.id}`" :to="pageUrl(page)" class="flex items-center gap-2 px-4 py-2.5 no-underline text-sm text-gray-900 hover:bg-gray-50">
        <font-awesome-icon :icon="['fas', 'file-lines']" class="text-gray-400" />
        <span class="sensitive">{{ page.title }}</span>
      </router-link>
      <p v-if="!subfolders.length && !pagesHere.length" class="px-4 py-6 text-sm text-gray-500">Nothing here. Set a page's Folder to "{{ stem || 'a name' }}" to put it here.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { breadcrumb, childFolders, folderOptions, folderPages, folderUrl, pageUrl, stemParts } from '@/utils/pageFolders';

const BTN = 'px-3 py-1.5 text-xs font-medium text-gray-800 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50';

export default {
  name: 'PagesFolder',
  components: { FontAwesomeIcon },
  inject: ['refreshMine'],
  props: {
    stem: { type: String, default: '' },
    pages: { type: Array, required: true },
  },
  data() {
    return { renaming: false, draft: '', error: '', BTN };
  },
  computed: {
    crumbs() {
      return breadcrumb(this.stem);
    },
    subfolders() {
      return childFolders(this.pages, this.stem);
    },
    pagesHere() {
      return folderPages(this.pages, this.stem);
    },
    moveTargets() {
      return folderOptions(this.pages, this.stem);
    },
  },
  methods: {
    folderUrl,
    pageUrl,
    startRename() {
      this.renaming = true;
      this.draft = this.crumbs[this.crumbs.length - 1].name;
    },
    async relocate(target) {
      this.error = '';
      try {
        await axios.post('/api/impact_analytics/agent-pages/move-stem/', { from: this.stem, to: target });
        await this.refreshMine();
        this.renaming = false;
        this.$router.replace(folderUrl(target));
      } catch (err) {
        this.error = err?.response?.data?.error || 'That did not work.';
      }
    },
    rename() {
      const parent = stemParts(this.stem).slice(0, -1);
      return this.relocate([...parent, this.draft.trim().replace(/\//g, '-')].join('/'));
    },
    moveFolder(value) {
      const name = stemParts(this.stem).slice(-1)[0];
      return this.relocate(value === '/' ? name : `${value}/${name}`);
    },
  },
};
</script>
